/*
 * Analog Theme
 *
 * Use this file to listen for the theme's Javascript events. Keeping your custom
 * Javascript in this file makes it easier to update Analog. To use this file, open
 * snippets/head-scripts.liquid and uncomment the custom.events.js script line.
 *
 * Commerce events use Shopify's standard storefront events (names prefixed
 * "shopify:"). Theme UI events keep the "theme:" prefix. The full list is in
 * the theme docs, and the reference is at
 * https://shopify.dev/docs/api/storefront-events-and-actions
 *
 * Migrating from the old theme:* commerce events? Each block below names the
 * old event it replaces.
 */

// Below are example event listeners. They listen for events that Analog
// fires in order to make it easier for you to add customizations.

function redirecttoFilteredUrl() {
  const topicFilter = window.localStorage.getItem("topicFilter");
  const categoryFilter = window.localStorage.getItem("categoryFilter");
  if (topicFilter && categoryFilter) {
    const topicFormatted = topicFilter
      .replace(/ /g, "-")
      .replace(/>/g, "-")
      .replace(/&/g, "amp")
      .toLowerCase();
    const categoryFormatted = categoryFilter.replace(/ /g, "-").toLowerCase();
    const newPath =
      "/blogs/rm/tagged/" + topicFormatted + "," + categoryFormatted;
    window.location.href = newPath;
  }
  if (!topicFilter && categoryFilter) {
    const categoryFormatted = categoryFilter.replace(/ /g, "-").toLowerCase();
    const newPath = "/blogs/rm/tagged/" + categoryFormatted;
    window.location.href = newPath;
  }
  if (topicFilter && !categoryFilter) {
    const topicFormatted = topicFilter
      .replace(/ /g, "-")
      .replace(/>/g, "-")
      .replace(/&/g, "amp")
      .toLowerCase();
    const newPath = "/blogs/rm/tagged/" + topicFormatted;
    window.location.href = newPath;
  }
  if (!topicFilter && !categoryFilter) {
    const newPath = "/blogs/rm";
    window.location.href = newPath;
  }
}

function handleBlogSelectorChange() {
  const categoriesSelect = document.getElementById("categories-select");
  const topicsSelect = document.getElementById("labels-select");
  const selectedCategory = categoriesSelect.value;
  const selectedTopic = topicsSelect.value;
  window.localStorage.setItem("categoryFilter", selectedCategory);
  window.localStorage.setItem("topicFilter", selectedTopic);
  redirecttoFilteredUrl();
}

document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.pathname;
  if (currentUrl.includes("/tagged")) {
    const topicFilter = window.localStorage.getItem("topicFilter");
    const categoryFilter = window.localStorage.getItem("categoryFilter");
    if (topicFilter) {
      const topicSelect = document.getElementById("labels-select");
      topicSelect.value = topicFilter;
    }
    if (categoryFilter) {
      const categorySelect = document.getElementById("categories-select");
      categorySelect.value = categoryFilter;
    }
  }
  const categoriesSelect = document.getElementById("categories-select");
  const labelsSelect = document.getElementById("labels-select");
  if (categoriesSelect && labelsSelect) {
    categoriesSelect.addEventListener("change", handleBlogSelectorChange);
    labelsSelect.addEventListener("change", handleBlogSelectorChange);
  }
});

// To CHANGE the cart from custom code, use Shopify's standard actions instead
// of calling /cart/add.js yourself - the theme's drawer, icon, and cart
// sections all react on their own:
//
//   await Shopify.actions.updateCart({ lines: [{ merchandiseId: 12345, quantity: 1 }] });
//   await Shopify.actions.openCart();
